<template>
  <div class="box" v-if="filters">
    <select
      v-model="selectedFilter"
      @change="handleSelect()"
      :disabled="disabled"
    >
      <option
        v-for="filter in filters"
        :key="filter.name"
        :value="filter.name"
        :selected="filter.name == selectedFilter"
        >{{ filter.displayName }}</option
      >
    </select>
  </div>
</template>

<script>
export default {
  props: ["filters", "label", "disabled"],
  data() {
    return {
      selectedFilter: this.filters ? this.filters[0].name : "",
    };
  },

  methods: {
    handleSelect() {
      this.$emit("refreshFilters", this.selectedFilter);
    },
  },
};
</script>

<style scoped>
.box select {
  background: #f7f8f9;
  color: #93a3ad;
  width: auto;
  border: none;
  min-width: 100px;
  font-size: 12px;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.2);
  -webkit-appearance: button;
  appearance: button;
  outline: none;
  height: 30px;
  padding-left: 10px;
  border-radius: 5px;
}

.box select:hover {
  color: black;
}

.box::before {
  content: "\f13a";
  position: absolute;
  top: 0;
  right: 0;
  width: 20%;
  height: 100%;
  text-align: center;
  font-size: 9px;
  line-height: 45px;
  color: rgba(255, 255, 255, 0.5);
  background-color: rgba(255, 255, 255, 0.1);
  pointer-events: none;
}

.box:hover::before {
  color: rgba(255, 255, 255, 0.6);
  background-color: rgba(255, 255, 255, 0.2);
}

.box select option {
  padding: 30px;
  border-radius: 5px;
}
</style>
